module.exports = __webpack_public_path__ + "static/media/core-supports-icon.b7bd7747.svg";